module.exports = __webpack_public_path__ + "img/heart.d4525e3d.svg";